import React, { Component } from "react";
import "./Print.scss";
import WearPiecesJSON from "../../data/WearPieces.json";
import arrayStar from "../../data/arrayStar";

export default class Print extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: `${new Date().getDate()} / ${new Date().getMonth() +
        1} / ${new Date().getFullYear()}`,
      // model:
      //   this.props.carInfo !== undefined
      //     ? this.props.carInfo.modelName
      //         .split(" ")[0]
      //         .toLowerCase()
      //         .replace(/\b\w/g, l => l.toUpperCase())
      //     : this.props.selectedModel,
      total: this.props.wearPartsCost + this.props.maintenanceCost
    };
  }

  showAdBlueDescription=()=>{
    if (this.props.precioNoIncluyeAdblue){
      return (
          <div className="maintenance-operations__subtitle">
            El precio no incluye AD-BLUE.
          </div>
        
      );
    }
    else return
  }
  render() {
    const hybridVerification = (
      <div key={"Vcheck"} className="rowFlex">
        <img className="starSize" alt="star" src="images/star.png" />
        <div className=" li-item.ng-star-inserted ">
          <b>Chequeo Integral del Sistema Híbrido.</b>
        </div>
      </div>
    );
    return (
      <div className="showToPrint">
        <div className="section-budget-resume">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                {/* <img className="budget-resume__header" alt="star" src="images/top_calculadora.png" /> */}
                <img className="budget-resume__header" alt="star" src="images/banner_lc.png" />
                {/* <div className="budget-resume__header">
                  <h1 className="big-title-print">
                    Calculadora de Mantenimiento
                  </h1>
                  <h2 className="medium-title-print">
                    Presupuesto de las operaciones de mantenimiento de tu Lexus
                  </h2>
                </div> */}

                <div className="budget-resume__data">
                  <div className="budget-resume__data-box">
                    <div className="data-box__title">INSTALACIÓN</div>
                    <div className="data-box__data">
                      {this.props.selectedWorkshops.DealershipName}
                      <br />
                      {`${this.props.selectedWorkshops.DealershipAddress} ${
                        this.props.selectedWorkshops.DealershipZipCode
                      }`}
                    </div>
                  </div>
                  <div className="budget-resume__data-box">
                    <div className="data-box__title">FECHA PRESUP.</div>
                    <div className="data-box__data">{this.state.date}</div>
                  </div>
                </div>

                <div className="budget-resume__icons">
                  <div className="budget-resume__icon-box">
                    <div className="icon-box__title">VEHÍCULO</div>
                    <div className="icon-box__img">
                      <img alt="" src="images/circle-icons/vehicle.png" />
                    </div>
                    <div className="icon-box__data">{`Lexus ${
                      this.props.selectedModel.nameCase.replace('Lexus ','')
                    }`}</div>
                  </div>

                  <div className="budget-resume__icon-box">
                    <div className="icon-box__title">MOTOR</div>
                    <div className="icon-box__img">
                      <img alt="" src="images/circle-icons/motor.png" />
                    </div>
                    <div className="icon-box__data">
                      {this.props.carInfo !== undefined
                        ? this.props.carInfo.engineName
                        : this.props.engineNameSelected}
                    </div>
                  </div>

                  <div className="budget-resume__icon-box">
                    <div className="icon-box__title">COMBUSTIBLE</div>
                    <div className="icon-box__img">
                      <img alt="" src="images/circle-icons/fuel.png" />
                    </div>
                    <div className="icon-box__data">
                      {this.props.carInfo !== undefined
                        ? this.props.carInfo.fuel
                        : this.props.fuelSelected}
                    </div>
                  </div>

                  <div className="budget-resume__icon-box">
                    <div className="icon-box__title">AÑO DE PRODUCCION</div>
                    <div className="icon-box__img">
                      <img
                        alt=""
                        src="images/circle-icons/production_year.png"
                      />
                    </div>
                    <div className="icon-box__data">
                      {this.props.carInfo !== undefined
                        ? this.props.carInfo.year
                        : this.props.yearSelected}
                    </div>
                  </div>

                  <div className="budget-resume__icon-box">
                    <div className="icon-box__title">TIPO DE CAMBIO</div>
                    <div className="icon-box__img">
                      <img alt="" src="images/circle-icons/change_type.png" />
                    </div>
                    <div className="icon-box__data">
                      {this.props.carInfo !== undefined
                        ? this.props.carInfo.gearBoxName
                        : this.props.gearBoxNameSelected}
                    </div>
                  </div>

                  <div className="budget-resume__icon-box">
                    <div className="icon-box__title">
                      AÑOS O NÚMERO DE KILOMETROS
                    </div>
                    <div className="icon-box__img">
                      <img alt="" src="images/circle-icons/kms.png" />
                    </div>
                    <div className="icon-box__data">
                      {this.props.distanceSelected}
                    </div>
                  </div>
                </div>

                <div className="budget-resume__budget-container">
                  <div className="budget-resume__title-line">
                    Este es tu presupuesto
                  </div>
                  <div className="budget-resume__red-line" />
                  <div className="budget-resume__quantity-box">
                    <table className="quantity-box__table">
                      <tbody>
                        <tr>
                          {/* <td>
                            <div className="quantity-box__title">
                              OPERACIONES DE MANTENIMIENTO
                            </div>
                            <div className="quantity-box__amount">
                              {this.props.maintenanceCost
                                .toFixed(2)
                                .replace(".", ",")}
                            </div>
                          </td> */}
                          {/* <td className="quantity-box__td-sign">+</td> */}
                          {/* <td>
                            <div className="quantity-box__title">
                              PIEZAS DE DESGASTE
                            </div>
                            <div className="quantity-box__amount">
                              {this.props.wearPartsCost
                                .toFixed(2)
                                .replace(".", ",")}
                            </div>
                          </td> */}
                          {/* <td className="quantity-box__td-sign">=</td> */}
                          <td className="quantity-box__td-result">
                            <div className="quantity-box__title">
                              TOTAL ESTIMADO
                              <span>
                                * Descuentos y promociones del Servicio Oficial no
                                incluidos.
                              </span>
                            </div>
                            <div className="quantity-box__amount">
                              {/* {this.state.total.toFixed(2).replace(".", ",")} */}
                              {(this.props.maintenanceCost + this.props.wearPartsCost).toFixed(2).replace(".", ",")}
                            </div>

                            <div className="quantity-box__extra-info">
                              {/* ¡TODO INCLUIDO! */}
                              <span>IVA y mano de obra incluidos</span>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="budget-resume__maintenance-operations">
                  <div className="maintenance-operations__title">
                    OPERACIONES DE MANTENIMIENTO
                  </div>
                  
                  <div className="maintenance-operations__subtitle">
                    Verificación
                  </div>
                  <div className="maintenance-operations__list-container">
                    {this.props.thingsToDo
                      ? this.props.thingsToDo.map((piece, i) => {
                          if (piece.cTipo.includes("V")) {
                            return (
                              <div
                                key={i}
                                id={i}
                                className=" li-item.ng-star-inserted maintenance-operations__list-item "
                              >
                                <img alt="star" src="images/pngegg.png" />{" "}
                                {piece.cDescripcion}
                              </div>
                            );
                          }
                        })
                      : null}
                    {/* <div className="rowFlex">
                      <img
                        className="starSize"
                        alt="star"
                        src="images/star.png"
                      />
                      <div className=" li-item.ng-star-inserted ">
                        <b>
                          Inspección del estado de salud del vehículo
                          (componentes mecánicos y <br /> electrónicos).
                        </b>
                      </div>
                    </div> */}
                    {/* {this.props.fuelSelected === "Híbrido" &&
                      hybridVerification}
                    {this.props.carInfo &&
                      this.props.carInfo.fuel === "Híbrido" &&
                      hybridVerification} */}
                  </div>

                  <div className="maintenance-operations__subtitle">
                    Reemplazo
                  </div>
                  <div className="maintenance-operations__list-container">
                    {this.props.thingsToDo
                      ? this.props.thingsToDo.map((piece, y) => {
                          if (piece.cTipo.includes("R")) {
                            return (
                              <div
                                id={y + "s"}
                                className=" li-item.ng-star-inserted maintenance-operations__list-item "
                              >
                                <img alt="star" src="images/pngegg.png" />{" "}
                                {piece.cDescripcion}
                              </div>
                            );
                          }
                        })
                      : null}
                  </div>

                  <div className="maintenance-operations__subtitle">
                    Limpieza
                  </div>
                  <div className="maintenance-operations__list-container">
                    {this.props.thingsToDo
                      ? this.props.thingsToDo.map((piece, y) => {
                          if (piece.cTipo.includes("L")) {
                            return (
                              <div
                                id={y + "s"}
                                className=" li-item.ng-star-inserted maintenance-operations__list-item "
                              >
                                <img alt="star" src="images/pngegg.png" />{" "}
                                {piece.cDescripcion}
                              </div>
                            );
                          }
                        })
                      : null}
                  </div>
                                    
                  {/* <div className="maintenance-operations__list-item maintenance-operations__list-item-legend">
                    <img alt="" src="images/star.png" /> Estas son las
                    operaciones que nos diferencian.
                  </div> */}
                </div>

                {/* {(this.props.pieces[0] === true ||
                  this.props.pieces[1] === true ||
                  this.props.pieces[2] === true ||
                  this.props.pieces[3] === true ||
                  this.props.pieces[4] === true ||
                  this.props.pieces[5] === true ||
                  this.props.pieces[6] === true ||
                  this.props.pieces[7] === true) && (
                  <div className="budget-resume__wear-parts">
                    <div className="wear-parts__title">PIEZAS DE DESGASTE</div>
                    <div className="wear-parts__list-container">
                      {Object.values(this.props.pieces).map(
                        (isPieceTrue, i) => {
                          if (isPieceTrue) {
                            return WearPiecesJSON.map((piece, j) => {
                              if (piece.id === i) {
                                return (
                                  <div className="paddingPrint wear-parts__list-item">
                                    <div
                                      key={i}
                                      className="wear-parts__list-item-image"
                                    >
                                      <img key={j} alt="" src={piece.img} />
                                    </div>
                                    <div className="wear-parts__list-item-info">
                                      <div className=" widthPrint list-item-info__title">
                                        {piece.name}
                                      </div>
                                      <div className="list-item-info__price">
                                        {this.props.wearPiecesInfo[i].totalField
                                          .toFixed(2)
                                          .toString()
                                          .replace(".", ",")}
                                      </div>
                                    </div>
                                  </div>
                                );
                              }
                            });
                          }
                        }
                      )}
                    </div>
                  </div>
                )} */}

                {/* {this.props.wearPiecesPlate && (
                  <div className="maintenance-operations__subtitle">
                    * El presupuesto de piezas de desgaste aquí mostrado
                    pertenece al vehículo con matrícula{" "}
                    <span className="styleSpan">
                      {this.props.wearPiecesPlate.toUpperCase()}.
                    </span>
                  </div>
                )} */}
                {/* {this.showAdBlueDescription()} */}
                {/* <div className="maintenance-operations__subtitle">
                  * Descuentos y promociones del Servicio Oficial no incluidos.
                </div> */}
                <div className="maintenance-conditions__text">
                  * Recambios, mano de obra y 21% IVA incluidos. SIGAUS (gestión de aceite, usado) no incluido.
                  (GESTIÓN DE ACEITES USADOS RD 679/2006 2 junio 2006)
                </div>
                <div className="maintenance-conditions__text">
                  * Estos precios están sujetos a cambios según las especificaciones particulares de cada
                    modelo, o modificaciones en referencias y precios unitarios. Consúltenos
                </div>
                <div className="maintenance-conditions__text">
                  * Este mantenimiento está calculado con aceite * El precio del mantenimiento está
                    calculado utilizando aceite sintético Lexus Genuine Motor Oil 5W30 PFE. Este aceite
                    posee mayor capacidad de trabajo a altas y bajas temperaturas que otros aceites no
                    sintéticos. Su utilización reduce la cantidad de cenizas generadas en el proceso de
                    combustión del motor evitando la obstrucción de las líneas de escape a la vez que
                    disminuye el consumo de combustible y los niveles de emisiones de CO2,
                    proporcionando una mayor protección del medio ambient
                </div>
                <div className="maintenance-conditions__text">
                  {/* No obstante, tenemos a su disposición otros aceites con especificaciones y precios
                  superiores que usted puede solicitar en cualquiera de nuestros servicios oficiales..
                  Este aceite cumple con las especificaciones técnicas del vehículo Lexus seleccionado, a
                  la vez que vela por un mantenimiento del vehículo a un precio económico.
                  No obstante, tenemos a su disposición otros aceites con especificaciones y precios
                  superiores que usted puede solicitar en cualquiera de nuestros servicios oficiales. */}
                  Con <b>LEXUS RELAX</b>, disfrute de 1 año o 15.000kms de garantía realizando el
                  mantenimiento en nuestros Centros Autorizados Lexus (prorrogable hasta 10 años o
                  185.000 kms) Consulte Términos y Condiciones en: <a href="https://www.lexusauto.es/propietarios/garantia/lexus-relax/terminos-y-condiciones-lexus-relax">www.lexusauto.es/propietarios/garantia/lexus-relax</a>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
